function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import highContrastMediaQuery from '../utils/high_contrast_media_query';
import { useTheme } from '@veneer/theme';
var useStyles = _ref => {
  var {
    newOnTop,
    position
  } = _ref;
  var theme = useTheme();
  return React.useMemo(() => {
    var _theme$elevation;
    return _extends({
      bottom: position === 'bottom' ? 0 : undefined,
      display: 'flex',
      flexDirection: newOnTop ? 'column-reverse' : 'column',
      maxHeight: '100%',
      position: 'fixed',
      right: 20,
      top: position === 'top' ? 20 : undefined,
      width: '87%',
      maxWidth: 360,
      zIndex: (_theme$elevation = theme.elevation) === null || _theme$elevation === void 0 ? void 0 : _theme$elevation.toast
    }, highContrastMediaQuery(theme));
  }, [newOnTop, position, theme]);
};
export default useStyles;